import styled from 'styled-components'
import { isMobile } from '../../../helpers/window.helper'

export const StyledProductItem = styled.div`
	display: flex;
	flex-direction: column;
	width: 250px;
	justify-content: flex-end;
	align-items: ${isMobile() ? 'center;' : ''};
	background-color: #fff;
	border-radius: 20px;
	transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1),
		box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	position: relative;
	height: 380px;

	&:hover {
		transform: scale(1.05) translateY(-8px);
		box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
		z-index: 2;
		cursor: pointer;
	}
`
